export default "__VITE_ASSET__Cs6WVa6l__"